import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import urlparam from 'urlparam';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import { createDateFilter } from '../../../../data/filters/schedule/createDateFilter';
import { useEvent } from '../../../../data/hooks/eventHooks';
import Scrollable from '../../../elements/Scrollable';
import LoadProgram from '../../../loaders/LoadProgram';
import ErrorBoundary from '../../../validate/ErrorBoundary';
import WaitWhileBusy from '../../../WaitWhileBusy';
import Screen from '../../Screen';
import EventScheduleFooter from './EventScheduleFooter';
import EventScheduleHeader from './EventScheduleHeader';
import ScheduleTabContent from './ScheduleTabContent';

function EventScheduleScreen(props) {
    const { eventId } = props,
        event = useEvent(eventId),
        { date, tab } = useParams(),
        dateFilter = useCallback(createDateFilter(event, date, { filterDateFormat: DATE_FORMAT_URL }), [date]),
        focusedRoundId = urlparam('round', false);

    const header = <EventScheduleHeader eventId={eventId} />,
        footer = <EventScheduleFooter eventId={eventId} dateFilter={dateFilter} />;

    return (
        <Screen header={header} footer={footer}>
            <Scrollable>
                <ScheduleTabContent event={event} date={date} dateFilter={dateFilter} tab={tab} focusedRoundId={focusedRoundId} />
            </Scrollable>
        </Screen>
    );
}

export default (props) => (
    <LoadProgram eventId={props.match.params.eventId}>
        <WaitWhileBusy>
            <ErrorBoundary altRoute="../../..">
                <EventScheduleScreen {...props.match.params} />
            </ErrorBoundary>
        </WaitWhileBusy>
    </LoadProgram>
);
